import React, { useState, useRef, useEffect } from 'react'
import { TextField } from '@material-ui/core'
import './styles.scss'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Avatar from '@material-ui/core/Avatar'
import PersonIcon from '@material-ui/icons/Person'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import Scrollchor from 'react-scrollchor'
import { DataGrid } from '@material-ui/data-grid'
import HowToVoteIcon from '@material-ui/icons/HowToVote'
import NumberFormat from 'react-number-format'
import ReactDataGrid from 'react-data-grid'
import RotateLeftIcon from '@material-ui/icons/RotateLeft'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import { PortraitPicture } from 'components/portraitPicture'

import districts from '../../data/districts.csv'
import communesDataVqh from '../../data/communes-data-vqh.csv'
import communesDataOfs from '../../data/communes-data-ofs.csv'

console.log(communesDataVqh)
console.log(communesDataOfs)

const useStyles = makeStyles(theme => ({
  item: {
    cursor: 'pointer'
  },
  text: {
    fontFamily: 'TamediaUI'
  },
  arrowIcon: {
    width: '0.5em',
    height: '0.5em'
  }
}))

interface Props {
  municipality: {}
  candidates: []
  handleSelectCandidate: () => void
}

export const Candidates = ({
  municipality,
  candidates,
  handleSelectCandidate
}: Props) => {
  const gotoCommuneInfos = useRef(null)

  console.log(municipality)
  console.log(candidates)

  const [
    showRepresentativenessTables,
    setShowRepresentativenessTables
  ] = useState(false)

  const columns = [
    {
      field: 'fullName',
      headerName: 'Nom',
      description: 'This column has a value getter and is not sortable.',
      sortable: true,
      flex: 1,
      valueGetter: params =>
        `${params.getValue('nom') || ''} ${params.getValue('prénom') || ''}`
    },
    {
      field: 'âge',
      headerName: 'Age',
      flex: 1
    },
    {
      field: 'liste',
      headerName: 'Liste',
      flex: 1
    }
  ]

  // Get the selected municiaplity data from the ofs
  const selectedCommuneDataOfs = municipality
    ? communesDataOfs.find(c => +c.code === +municipality.code)
    : null

  // Constructs the political parties list of the selected municipality
  if (selectedCommuneDataOfs)
    selectedCommuneDataOfs.politique = [
      {
        parti: 'PS',
        pct: selectedCommuneDataOfs.PS
      },
      {
        parti: 'PDC',
        pct: selectedCommuneDataOfs.PDC
      },
      {
        parti: 'PLR',
        pct: selectedCommuneDataOfs.PLR
      },
      {
        parti: 'UDC',
        pct: selectedCommuneDataOfs.UDC
      },
      {
        parti: 'PEV/PCS',
        pct: selectedCommuneDataOfs['PEV/PCS']
      },
      {
        parti: "Vert'libéraux",
        pct: selectedCommuneDataOfs.PVL
      },
      {
        parti: 'PBD',
        pct: selectedCommuneDataOfs.PBD
      },
      {
        parti: 'PST/Sol.',
        pct: selectedCommuneDataOfs['PST/Sol.']
      },
      {
        parti: 'Les Verts',
        pct: selectedCommuneDataOfs.PES
      },
      {
        parti: 'Petits partis de droite',
        pct: selectedCommuneDataOfs['Petits partis de droite']
      }
    ].sort((a, b) => b.pct - a.pct)

  const selectedCommuneDataVqh = municipality
    ? communesDataVqh.find(c => +c.id === +municipality.code)
    : null

  console.log(selectedCommuneDataOfs)
  console.log(selectedCommuneDataVqh)

  const count = selectedCommuneDataOfs
    ? {
        ages: [
          {
            label: '18-30 ans',
            count: candidates.filter(c => c['âge'] >= 18 && c['âge'] < 30)
              .length,
            municipalityPct: selectedCommuneDataOfs['ages pct 18-30']
          },
          {
            label: '30-45 ans',
            count: candidates.filter(c => c['âge'] >= 30 && c['âge'] < 45)
              .length,
            municipalityPct: selectedCommuneDataOfs['ages pct 30-45']
          },
          {
            label: '45-60 ans',
            count: candidates.filter(c => c['âge'] >= 45 && c['âge'] < 60)
              .length,
            municipalityPct: selectedCommuneDataOfs['ages pct 45-60']
          },
          {
            label: 'Plus de 60 ans',
            count: candidates.filter(c => c['âge'] >= 60).length,
            municipalityPct: selectedCommuneDataOfs['ages pct >60']
          }
        ],
        femmes: [
          {
            label: 'Femmes',
            count: candidates.filter(c => c.genre === 'Femme').length,
            municipalityPct: 50
          },
          {
            label: 'Hommes',
            count: candidates.filter(c => c.genre === 'Homme').length,
            municipalityPct: 50
          }
        ],
        secteursPro: [
          {
            label: 'Primaire',
            count: candidates.filter(c => c.secteur === 'Primaire').length,
            municipalityPct:
              (+selectedCommuneDataOfs['tot - Secteur primaire'] /
                (+selectedCommuneDataOfs['tot - Secteur primaire'] +
                  +selectedCommuneDataOfs['tot - Secteur secondaire'] +
                  +selectedCommuneDataOfs['tot - Secteur tertiaire'])) *
              100
          },
          {
            label: 'Secondaire',
            count: candidates.filter(c => c.secteur === 'Secondaire').length,
            municipalityPct:
              (+selectedCommuneDataOfs['tot - Secteur secondaire'] /
                (+selectedCommuneDataOfs['tot - Secteur primaire'] +
                  +selectedCommuneDataOfs['tot - Secteur secondaire'] +
                  +selectedCommuneDataOfs['tot - Secteur tertiaire'])) *
              100
          },
          {
            label: 'Tertiaire',
            count: candidates.filter(c => c.secteur === 'Tertiaire').length,
            municipalityPct:
              (+selectedCommuneDataOfs['tot - Secteur tertiaire'] /
                (+selectedCommuneDataOfs['tot - Secteur primaire'] +
                  +selectedCommuneDataOfs['tot - Secteur secondaire'] +
                  +selectedCommuneDataOfs['tot - Secteur tertiaire'])) *
              100
          }
        ]
      }
    : null

  return (
    <>
      {selectedCommuneDataOfs && (
        <div
          className='ui vertical grey segment'
          id='commune-infos'
          style={{ paddingBottom: 0, backgroundColor: '#3237751a' }}
        >
          <div className='ui container'>
            <div className='commune-portrait'>
              <div className='ui vertical very fitted segment main-title'>
                <div className='ui center aligned'>
                  <img
                    src={require('../../images/flag-blue.svg')}
                    style={{ width: '60px' }}
                  />
                  <h4>{selectedCommuneDataOfs.nom}</h4>
                </div>
                <div>
                  <small>
                    {
                      districts.find(
                        d => d.BZNR === selectedCommuneDataOfs['code district']
                      ).BZNAME
                    }
                  </small>
                </div>
              </div>
              <div className='info-container'>
                <div className='col col-x'>
                  <div className='panel-title'>
                    Population <small>au 31.12.2019</small>
                  </div>
                  <div className='col-content'>
                    <div>Habitants</div>
                    <div>
                      <span className='big-number'>
                        <NumberFormat
                          value={
                            selectedCommuneDataOfs['population - habitants']
                          }
                          displayType='text'
                          thousandSeparator='’'
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div className='col col-y'>
                  <div className='panel-title'>Type de conseil</div>
                  <div className='col-content'>
                    <div className='votation-type-grid'>
                      <div className='votation-type-grid-a'>
                        <div>Conseil</div>
                        <div
                          className='votation-type'
                          style={{ paddingBottom: '.5em' }}
                        >
                          <span className='big-number'>
                            {selectedCommuneDataVqh['Types de conseil'] === 'CC'
                              ? 'Communal'
                              : 'Général'}
                          </span>
                        </div>
                        {selectedCommuneDataVqh['Types de conseil'] ===
                          'CC' && (
                          <div
                            className='votation-type'
                            style={{
                              borderTop: '1px solid #f1f2f4',
                              paddingTop: '.5em',
                              paddingBottom: '.5em'
                            }}
                          >
                            Scrutin{' '}
                            {selectedCommuneDataVqh["Mode d'élection"] === 'MAJ'
                              ? 'majoritaire'
                              : 'proportionnel'}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col col-z'>
                  <div className='panel-title'>Sièges à pourvoir</div>
                  <div className='col-content'>
                    {selectedCommuneDataVqh['Types de conseil'] === 'CG' ? (
                      <div className='seats-col seats-col-b'>
                        <div>Municipalité</div>
                        <span className='big-number'>
                          {selectedCommuneDataVqh['Conseillers municipaux']}
                        </span>
                      </div>
                    ) : (
                      <div className='seats-grid'>
                        <div className='seats-col seats-col-a'>
                          <div>Municipalité</div>
                          <span className='big-number'>
                            {selectedCommuneDataVqh['Conseillers municipaux']}
                          </span>
                        </div>
                        <div className='seats-col seats-col-b'>
                          <div>
                            {selectedCommuneDataVqh['Types de conseil'] === 'CC'
                              ? 'Conseil'
                              : 'Conseil'}
                          </div>
                          <span className='big-number'>
                            {selectedCommuneDataVqh['Types de conseil'] === 'CC'
                              ? selectedCommuneDataVqh['Conseillers communaux']
                              : '/'}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='col col-e'>
                  <div className='panel-title'>
                    Orientation politique de la commune{' '}
                    <small>(élections fédérales de 2019)</small>
                  </div>
                  <div className='col-content'>
                    <PartisTable data={selectedCommuneDataOfs.politique} />
                  </div>
                </div>

                {selectedCommuneDataVqh['Tient des élections'] === 'TRUE' && (
                  <div className='col col-c'>
                    <div className='panel-title'>
                      Représentativité des candidats
                    </div>
                    <div className='col-content'>
                      <div className='representativeness'>
                        <RepresentativenessTable
                          open={showRepresentativenessTables}
                          title='Sexes'
                          data={count.femmes}
                          municipalityCandidatesCount={candidates.length}
                        />
                        <RepresentativenessTable
                          open={showRepresentativenessTables}
                          title='Secteurs économiques'
                          data={count.secteursPro}
                          municipalityCandidatesCount={
                            candidates.filter(c => c.secteur !== '').length
                          }
                        />
                        <RepresentativenessTable
                          open={showRepresentativenessTables}
                          title='Âges'
                          data={count.ages}
                          municipalityCandidatesCount={candidates.length}
                        />
                      </div>
                      <div
                        className='more-infos'
                        onClick={() => {
                          setShowRepresentativenessTables(
                            !showRepresentativenessTables
                          )
                        }}
                      >
                        <div className='pseudo-link'>
                          <span>
                            {showRepresentativenessTables ? 'Masquer' : 'Voir'}{' '}
                            le détail
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div />
            </div>
          </div>
          {candidates.length > 0 ? (
            <div className='ui blue vertical segment candidates-list'>
              <div className='ui container' style={{ position: 'relative' }}>
                <div className='panel-title'>Les candidats</div>
                <div className='candidates-list-container'>
                  {candidates.map((candidate, i) => (
                    <div
                      key={candidate.id}
                      className='candidate-item'
                      onClick={() => {
                        handleSelectCandidate(candidate)
                      }}
                    >
                      <div className='candidate-portrait'>
                        {candidate.sortant && (
                          <div className='candidate-outgoing-icon'>
                            <RotateLeftIcon
                              style={{ color: '#202346', fontSize: '1.45em' }}
                            />
                          </div>
                        )}
                        <PortraitPicture
                          id={candidate.id}
                          genre={candidate.genre}
                        />
                      </div>
                      <div className='candidate-infos'>
                        <div>
                          <b>
                            {candidate['prénom']} {candidate.nom}
                          </b>
                        </div>
                        {candidate['âge'] !== '' && (
                          <div>{candidate['âge']} ans</div>
                        )}
                        <div>{candidate.profession}</div>
                        <div>{candidate.liste}</div>
                      </div>
                    </div>
                  ))}
                </div>
                {/* <div style={{ height: '300px' }}>
                  <ReactDataGrid
                    rowRenderer={RowRenderer}
                    columns={columns}
                    rowGetter={candidates}
                    rowsCount={5}
                  />
                      </div>  */}
              </div>
            </div>
          ) : (
            <div className='ui blue vertical segment candidates-list'>
              <div
                className='ui center aligned text container'
                style={{
                  position: 'relative',
                  color: '#ffffff',
                  fontFamily: 'TamediaUI'
                }}
              >
                Cette commune ne tient pas d'élection.
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}

const PartisTable = ({ data }) => {
  const [showAll, setShowAll] = useState(false)

  return (
    <>
      <table className='bar-chart-list'>
        <colgroup>
          <col style={{ width: '30%' }} />
          <col style={{ width: '70%' }} />
        </colgroup>
        <tbody>
          {data.slice(0, showAll ? data.length : 3).map((p, i) => (
            <tr key={i}>
              <td className='chart-bar-label'>
                <b>{p.parti}</b>
              </td>
              <td>
                <div className='chart-value'>{p.pct}%</div>
                <div className='chart-bar-container'>
                  <div className='chart-bar' style={{ width: p.pct + '%' }} />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className='ui center aligned'>
        <div
          style={{ textAlign: 'center' }}
          className='pseudo-link'
          onClick={() => {
            setShowAll(!showAll)
          }}
        >
          <span>{showAll ? 'Réduire la liste' : 'Voir toute la liste'}</span>
          {/* <i className={`ui icon chevron ${showAll ? 'up' : 'down'}`} /> */}
        </div>
      </div>
    </>
  )
}

const RepresentativenessTable = ({
  open,
  title,
  data,
  municipalityCandidatesCount
}) => {
  const [showTable, setShowTable] = useState(open)
  const representativenessMean = Math.round(
    100 -
      data.reduce(
        (a, b) =>
          a +
          Math.abs(
            (b.count / municipalityCandidatesCount) * 100 - b.municipalityPct
          ),
        0
      ) /
        data.length
  )

  useEffect(() => {
    setShowTable(open)
  }, [open])

  const getRepresentativenessMeanWord = val => {
    const words = [
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'très basse',
      'basse',
      'basse',
      'basse',
      'moyenne',
      'moyenne',
      'bonne',
      'bonne',
      'excellente',
      'excellente'
    ]
    return words[Math.round((val / 100) * 20)]
  }

  return (
    <div className='rep-table-container'>
      <div className='title' dangerouslySetInnerHTML={{ __html: title }} />
      <div>
        <div className='rep-circle-container'>
          <div className='left'>
            <RepresentativenessCircle value={representativenessMean} />
            <div className='rep-circle-text'>{representativenessMean}%</div>
          </div>
          <div className='right'>
            <div className='grey small text'>
              Représentativité{' '}
              <b>{getRepresentativenessMeanWord(representativenessMean)}</b>
            </div>
          </div>
        </div>
      </div>
      {showTable && (
        <div className='rep-table'>
          <div className='legend'>
            <div className='legend-item'>
              <div className='legend-block-commune' />
              Commune
            </div>
            <div className='legend-item'>
              <div className='legend-block-candidats' />
              Candidats
            </div>
          </div>
          {data.map((d, i) => (
            <div key={i} className='rep-chart-item'>
              <div className='rep-chart-label'>
                <b>{d.label}</b>
              </div>
              <div>
                <RepresentativenessB
                  municipalityCandidatesCount={municipalityCandidatesCount}
                  candidatesCount={d.count}
                  municipalityPct={d.municipalityPct}
                />
              </div>
            </div>
          ))}
        </div>
      )}
      {/* <div
        style={{ textAlign: 'center' }}
        className='pseudo-link'
        onClick={() => {
          setShowTable(!showTable)
        }}
      >
        <span>{showTable ? 'Masquer' : 'Afficher'} le détail</span>
      </div> */}
    </div>
  )
}

const RepresentativenessB = ({
  municipalityCandidatesCount,
  candidatesCount,
  municipalityPct
}) => {
  const candidatesPct = (candidatesCount / municipalityCandidatesCount) * 100
  const candidatesDiff = Math.abs(
    Math.round(
      candidatesCount - (municipalityCandidatesCount * municipalityPct) / 100
    )
  )

  return (
    <div className='rep-chart-b'>
      <div className='rep-chart-bars'>
        <div className='line line-25' />
        <div className='line line-50' />
        <div className='line line-75' />

        <div className='rep-bar-container'>
          {/* <div className='rep-bar-value'>{Math.round(municipalityPct)}%</div> */}
          <div className='rep-bar-b-full'>
            <div
              className='rep-bar-b municipality'
              style={{
                width:
                  (Math.abs(municipalityPct) > 0
                    ? Math.abs(municipalityPct)
                    : 1) + '%'
              }}
            />
          </div>
        </div>
        <div className='rep-bar-container'>
          {/* <div className='rep-bar-value'>{Math.round(candidatesPct)}%</div> */}
          <div className='rep-bar-b-full'>
            <div
              className='rep-bar-b candidates'
              style={{
                width:
                  (Math.abs(candidatesPct) > 0 ? Math.abs(candidatesPct) : 1) +
                  '%'
              }}
            />
          </div>
        </div>
      </div>
      <div
        className={`rep-chart-diff ${
          candidatesPct - municipalityPct > 0
            ? 'more'
            : candidatesPct - municipalityPct < 0
            ? 'less'
            : ''
        }`}
      >
        {candidatesPct - municipalityPct > 0 ? '+' : ''}
        {Math.round(candidatesPct - municipalityPct)}
        <small>%</small>
      </div>

      {candidatesDiff > 0 && (
        <div className='rep-chart-infos'>
          <div className='text grey small'>
            {candidatesPct - municipalityPct > 0
              ? `${candidatesDiff} candidat${
                  candidatesDiff > 1 ? 's' : ''
                } de trop`
              : `Il manque ${candidatesDiff} candidat${
                  candidatesDiff > 1 ? 's' : ''
                }`}
          </div>
        </div>
      )}
    </div>
  )
}

const RepresentativenessCircle = ({ value }) => {
  return (
    <div className='rep-circle'>
      <div
        className='rep-circle-value'
        style={{ marginLeft: ((100 - value) * 100) / 100 + 'px' }}
      />
    </div>
  )
}
